import MarketingPage from "./_shared/MarketingPage";
import { Swoosh } from "./_shared/Hero";

export default function WieFunktioniertVitanara() {
  return (
    <MarketingPage
      eyebrow="Information · Ablauf"
      h1={
        <>
          Wie funktioniert Vitanara? — Schritt für{" "}
          <Swoosh>Schritt</Swoosh> zum Buch
        </>
      }
      lead={
        <>
          Vitanara ist im Kern eine sehr alte Idee mit neuer Technik. Ein
          Mensch erzählt, jemand hört zu, am Ende entsteht ein Buch. Was sich
          verändert hat: die zuhörende Instanz ist Tag und Nacht erreichbar,
          geduldig und ohne eigene Agenda. Konrad und Ida sind{" "}
          <strong>KI-Biografen</strong> — entwickelt in Schleswig-Holstein,
          geprüft von Menschen.
        </>
      }
      sections={[
        {
          h2: "Was bei einem Anruf passiert",
          body: (
            <>
              <p style={{ margin: "0 0 12px" }}>
                Die erzählende Person wählt eine deutsche Festnetznummer. Nach
                drei oder vier Klingelzeichen meldet sich Konrad oder Ida — je
                nachdem, wer gerade verfügbar ist. Ein kurzer Gruß, dann ein
                offener Einstieg: „Wo möchten Sie heute anfangen?“
              </p>
              <p style={{ margin: 0 }}>
                Die Stimmen sind ruhig, das Tempo gelassen. Es wird nichts
                erzwungen, nichts ausgefragt, nichts protokolliert in einer
                Weise, die sich für die erzählende Person nach Verhör anfühlt.
                Wer mag, redet zwei Stunden. Wer nur einen Satz loswerden
                will, legt nach einer Minute auf.
              </p>
            </>
          ),
        },
        {
          h2: "Wie aus Gesprächen ein Buch wird",
          body: (
            <>
              <p style={{ margin: "0 0 12px" }}>
                Nach jedem Anruf wird das Gesagte transkribiert und in die
                wachsende Manuskript-Struktur einsortiert. Nach rund acht
                Wochen liegt ein Rohmanuskript vor, das ein menschlicher
                Lektor durchsieht: Lesefluss, Stimmigkeit, Faktenchecks bei
                historischen Daten, behutsame Korrektur ohne den Tonfall zu
                glätten.
              </p>
              <p style={{ margin: 0 }}>
                Im Anschluss wird gesetzt — in einer ruhigen, klassischen
                Buchtypografie, mit Fotos, die die Familie nachreicht. Druck
                und Bindung erfolgen in Deutschland. Das fertige Buch trifft
                nach rund zwölf Wochen ab erstem Anruf ein.
              </p>
            </>
          ),
        },
        {
          h2: "Was Konrad und Ida sind",
          body: (
            <>
              <p style={{ margin: "0 0 12px" }}>
                Konrad und Ida sind keine echten Menschen, sondern sorgfältig
                entwickelte Sprachsysteme. Sie wurden trainiert, biografische
                Gespräche zu führen — zuzuhören, nachzufragen, einzuordnen.
                Sie sind explizit <strong>keine Therapeuten</strong>,{" "}
                <strong>keine Seelsorger</strong> und treffen keine Aussagen
                über Lebensentscheidungen.
              </p>
              <p style={{ margin: 0 }}>
                Vor dem Druck prüft ein Mensch. Vor dem Versand auch.
              </p>
            </>
          ),
        },
        {
          h2: "Was Vitanara nicht ist",
          body: (
            <>
              <p style={{ margin: "0 0 12px" }}>
                Vitanara ist nicht für Krisenintervention. Wer Suizidgedanken
                hat oder akut Hilfe braucht, ist bei der{" "}
                <strong>Telefonseelsorge</strong> (0800 1110111) richtig —
                rund um die Uhr, kostenfrei, mit echten Menschen.
              </p>
              <p style={{ margin: 0 }}>
                Vitanara ist auch nicht für investigative oder rechtliche
                Zwecke gedacht. Aufnahmen entstehen unter dem ausdrücklichen
                Verständnis, dass es um Erinnerungen geht, nicht um
                Beweisführung.
              </p>
            </>
          ),
        },
      ]}
      faqs={[
        {
          q: "Hört Vitanara mit, wenn niemand anruft?",
          a: "Nein. Es werden ausschließlich aktive Telefongespräche aufgenommen, die die erzählende Person selbst startet.",
        },
        {
          q: "Werden die Aufnahmen für KI-Training verwendet?",
          a: "Nein. Die Aufnahmen bleiben ausschließlich für das Buchprojekt im Einsatz.",
        },
        {
          q: "Wie ist Vitanara entstanden?",
          a: "Vitanara wird in Schleswig-Holstein entwickelt. Die Idee entstand aus dem Wunsch, Gespräche mit einer Großmutter zu sichern, bevor es zu spät ist.",
        },
      ]}
      crossLinks={[
        {
          to: "/biografie-schreiben-lassen",
          label: "Biografie schreiben lassen",
          blurb:
            "Was klassische Biografen anders machen — und was bei Vitanara bleibt.",
        },
        {
          to: "/preise",
          label: "Preise",
          blurb:
            "Was kostet eine Biografie? Während der Beta für ausgewählte Familien kostenlos.",
        },
        {
          to: "/datenschutz",
          label: "Datenschutz und Rechte",
          blurb:
            "DSGVO-konforme Datenhaltung, Server in Frankfurt, Rechte bei der erzählenden Person.",
        },
      ]}
    />
  );
}
